import ColumnSet from '@/components/grid/columns/column-set';
import store from '@/store';
import BADGES_COLOR_MAP from '@/data/badges-color-map';
import _ from '@/common/helpers';
import auth from '@/common/auth/auth';

export default new ColumnSet({
    id: 'credit-memos-list',
    store,
    version: 4,
    defaultColumns: [
        {
            name: 'number',
            type: 'link',
            value: item => `${item.number}`.padStart(6, '0'),
            to: ({fields}) => ({
                name: 'credit-memo-details',
                params: {
                    id: fields.id,
                },
            }),
            predicate: auth.$pages['credit-memo-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            style: {truncate: true},
            sortable: true,
            sticky: true,
        },
        {
            header: 'Customer',
            name: 'customerId',
            type: 'link',
            expand: 'customer',
            value: fields => _.getIdentifier({concat: ['firstName', 'lastName']})(fields._embedded.customer.primaryAddress || fields._embedded.customer),
            to: ({fields}) => ({
                name: 'customer-details',
                params: {
                    id: fields.customerId,
                },
            }),
            predicate: auth.$pages['customer-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
        },
        {
            name: 'type',
            type: 'badge',
            map: BADGES_COLOR_MAP.creditMemoType,
        },
        {
            name: 'status',
            type: 'badge',
            map: BADGES_COLOR_MAP.creditMemoStatus,
        },
        {
            name: 'reason',
        },
        {
            header: 'Issued On',
            name: 'createdTime',
            type: 'datetime',
            sortable: true,
        },
        {
            header: 'Processed On',
            name: 'updatedTime',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'currency',
        },
        {
            name: 'totalCredit',
            type: 'numeric',
            approx: false,
            currency: 'currency',
            format: 'currency',
            sortable: true,
        },
        {
            name: 'unusedCredit',
            type: 'numeric',
            approx: false,
            currency: 'currency',
            format: 'currency',
            sortable: true,
        },
    ],
    otherColumns: [
        {
            name: 'taxCredit',
            type: 'numeric',
            approx: false,
            currency: 'currency',
            format: 'currency',
            sortable: true,
        },
        {
            name: 'shippingCredit',
            type: 'numeric',
            approx: false,
            currency: 'currency',
            format: 'currency',
            sortable: true,
        },
        {
            name: 'outsideCredit',
            type: 'numeric',
            approx: false,
            currency: 'currency',
            format: 'currency',
            sortable: true,
        },
        {
            name: 'revision',
            type: 'numeric',
            sortable: true,
        },
    ],
});
